import { render, staticRenderFns } from "./BimProgressAdmin.vue?vue&type=template&id=01a996b5&scoped=true"
import script from "./BimProgressAdmin.vue?vue&type=script&lang=js"
export * from "./BimProgressAdmin.vue?vue&type=script&lang=js"
import style0 from "./BimProgressAdmin.vue?vue&type=style&index=0&id=01a996b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a996b5",
  null
  
)

export default component.exports